import { FuelCard } from '@frete.com/fuel-react';
import { DS_TOKENS } from 'constants/styled.contants';
import { useCardStates } from 'hooks/openSearchTrucker/useCardStates';
import React from 'react';
import Divergence from './States/Divergence';
import Empty from './States/Empty';
import Error from './States/Error';
import Loading from './States/Loading';
import NotActive from './States/NotActive';
import TruckerSummary from './TruckerSummary';
import * as Styled from './styled';

const Card = () => {
  const { showDivergence, showEmpty, showError, showLoading, showNotActive, showTruckerSummary } = useCardStates();

  return (
    <Styled.Wrapper data-testid="open-search-mobile-card">
      <FuelCard backgroundColor={DS_TOKENS.color.background.neutral.default}>
        <Styled.ContentWrapper slot="content">
          {showLoading && <Loading />}
          {showTruckerSummary && <TruckerSummary />}
          {showError && <Error />}
          {showEmpty && <Empty />}
          {showNotActive && <NotActive />}
          {showDivergence && <Divergence />}
        </Styled.ContentWrapper>
      </FuelCard>
    </Styled.Wrapper>
  );
};

export default Card;
